var jsonData = null;
var pageData = null;
var cardCache = {};
var resultsColumn = $('[data-whatson-listing-results]');
var paginationDiv = $('[data-whatson-listing-pagination]');
var filterRow = $('body.whats-on .whats-on-section-listing .row-filter');

$(function () {


	var scrollTop = $(window).scrollTop();
    filterStuck(scrollTop);

    var section = getUrlParameter('type') ?? '';
    if (section == 'events') {
        $('.location-dropdown').parent().show();
        $('.price-dropdown').parent().show();
    }

    var sort = getUrlParameter('sort') ?? false;
    if (!sort) {
        sort = 'recent';
    }
    $('.whats-on-section-listing .btn-sort strong').text($('[data-whatson-listing-sort][data-sort="' + sort + '"]').text());
    $('[data-whatson-listing-sort][data-sort="' + sort + '"]').addClass('active');
    

    var category = getUrlParameter('category');
    if (!category) {
        category = 'all';
    }
    $('.whats-on-section-listing .btn-category strong').text($('[data-whatson-listing-category][data-category="' + category + '"]').text());
    $('[data-whatson-listing-category][data-category="' + category + '"]').addClass('active');
    
    var location = getUrlParameter('location');
    if (!location) {
        location = 'all';
    }
    $('.whats-on-section-listing .btn-location strong').text($('[data-whatson-listing-location][data-location="' + location + '"]').text());
    $('[data-whatson-listing-location][data-location="' + location + '"]').addClass('active');
    
    var price = getUrlParameter('price');
    if (!price) {
        price = 'all';
    }
    $('.whats-on-section-listing .btn-price strong').text($('[data-whatson-listing-price][data-price="' + price + '"]').text());
    $('[data-whatson-listing-price][data-price="' + price + '"]').addClass('active');
    
    var page = getUrlParameter('page') ?? '';

    if (section) {
        $('[data-whatson-listing-filter]').removeClass('btn-fill');
        $('[data-whatson-listing-filter][data-section="' + section + '"]').addClass('btn-fill');
    }
    fetchWhatsOnData(section, location, price, category, sort, page);

});


// SCROLL

$(window).on('scroll', function(e) {

	var scrollTop = $(window).scrollTop();
    filterStuck(scrollTop);

});


function preloadCards(callback) {
    var preloadIndex = 0;
    // console.log(performance.now().toFixed(2) + ' in preloadCards')
    function preloadNextCard() {
        if (preloadIndex < jsonData.length) {
            var item = jsonData[preloadIndex];

            cardCache[item.id] = item.html;
            // console.log(performance.now().toFixed(2) + ' before preloadNextCard')
            preloadIndex++;
            preloadNextCard();

        } else {
            callback(); // Continue with the main logic after preloading
        }
    }

    preloadNextCard();
}


$('[data-whatson-listing-filter]').on("click", function(e) {
    $('[data-whatson-listing-filter]').removeClass('btn-fill');
    $(this).addClass('btn-fill');
    var section = $(this).attr('data-section');
    var category = getUrlParameter('category') ?? '';
    if (!category) {
        category = 'all';
    }
    var location = getUrlParameter('location') ?? '';
    if (!location || section != 'events') {
        location = 'all';
        $('[data-whatson-listing-location]').removeClass('active');
        $('[data-whatson-listing-location][data-location="all"]').addClass('active');
        $('.whats-on-section-listing .btn-location strong').text('All');
    }
    var price = getUrlParameter('price') ?? '';
    if (!price || section != 'events') {
        price = 'all';
        $('[data-whatson-listing-price]').removeClass('active');
        $('[data-whatson-listing-price][data-price="all"]').addClass('active');
        $('.whats-on-section-listing .btn-price strong').text('All');
    }
    if (section == 'events') {
        $('.location-dropdown').parent().show();
        $('.price-dropdown').parent().show();
    } else {
        $('.location-dropdown').parent().hide();
        $('.price-dropdown').parent().hide();
    }
    var sort = getUrlParameter('sort') ?? '';
    if (!sort) {
        sort = 'recent';
    }
    fetchWhatsOnData(section, location, price, category, sort, 1)
    console.log('section ' + section);

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('location', location);
    url.searchParams.set('price', price);
    url.searchParams.set('category', category);
    url.searchParams.set('type', section);
    url.searchParams.set('sort', sort);
    url.searchParams.set('page', 1);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


$('[data-whatson-listing-sort]').on("click", function(e) {
    $('[data-whatson-listing-sort]').removeClass('active');
    $(this).addClass('active');
    var sort = $(this).attr('data-sort');
    var section = getUrlParameter('type') ?? '';
    if (!section) {
        section = 'all';
    }
    var category = getUrlParameter('category') ?? '';
    if (!category) {
        category = 'all';
    }
    var location = getUrlParameter('location') ?? '';
    if (!location) {
        location = 'all';
    }
    var price = getUrlParameter('price') ?? '';
    if (!price) {
        price = 'all';
    }
    fetchWhatsOnData(section, location, price, category, sort, 1)

    $('.whats-on-section-listing .btn-sort strong').text($(this).find('.title').text());

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('type', section);
    url.searchParams.set('category', category);
    url.searchParams.set('location', location);
    url.searchParams.set('price', price);
    url.searchParams.set('sort', sort);
    url.searchParams.set('page', 1);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


$('[data-whatson-listing-category]').on("click", function(e) {
    $('[data-whatson-listing-category]').removeClass('active');
    $(this).addClass('active');
    var category = $(this).attr('data-category');
    var section = getUrlParameter('type') ?? '';
    if (!section) {
        section = 'all';
    }
    var location = getUrlParameter('location') ?? '';
    if (!location) {
        location = 'all';
    }
    var price = getUrlParameter('price') ?? '';
    if (!price) {
        price = 'all';
    }
    var sort = getUrlParameter('sort') ?? '';
    if (!sort) {
        sort = 'recent';
    }
    fetchWhatsOnData(section, location, price, category, sort, 1)

    $('.whats-on-section-listing .btn-category strong').text($(this).find('.title').text());

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('type', section);
    url.searchParams.set('location', location);
    url.searchParams.set('price', price);
    url.searchParams.set('category', category);
    url.searchParams.set('sort', sort);
    url.searchParams.set('page', 1);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


$('[data-whatson-listing-location]').on("click", function(e) {
    $('[data-whatson-listing-location]').removeClass('active');
    $(this).addClass('active');
    var location = $(this).attr('data-location');
    var price = getUrlParameter('price') ?? '';
    if (!price) {
        price = 'all';
    }
    var section = getUrlParameter('type') ?? '';
    if (!section) {
        section = 'all';
    }
    var category = getUrlParameter('category') ?? '';
    if (!category) {
        category = 'all';
    }
    var sort = getUrlParameter('sort') ?? '';
    if (!sort) {
        sort = 'recent';
    }
    fetchWhatsOnData(section, location, price, category, sort, 1)

    $('.whats-on-section-listing .btn-location strong').text($(this).find('.title').text());

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('type', section);
    url.searchParams.set('location', location);
    url.searchParams.set('price', price);
    url.searchParams.set('category', category);
    url.searchParams.set('sort', sort);
    url.searchParams.set('page', 1);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


$('[data-whatson-listing-price]').on("click", function(e) {
    $('[data-whatson-listing-price]').removeClass('active');
    $(this).addClass('active');
    var price = $(this).attr('data-price');
    var location = getUrlParameter('location') ?? '';
    if (!location) {
        location = 'all';
    }
    var section = getUrlParameter('type') ?? '';
    if (!section) {
        section = 'all';
    }
    var category = getUrlParameter('category') ?? '';
    if (!category) {
        category = 'all';
    }
    var sort = getUrlParameter('sort') ?? '';
    if (!sort) {
        sort = 'recent';
    }
    fetchWhatsOnData(section, location, price, category, sort, 1)

    $('.whats-on-section-listing .btn-price strong').text($(this).find('.title').text());

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('type', section);
    url.searchParams.set('location', location);
    url.searchParams.set('price', price);
    url.searchParams.set('category', category);
    url.searchParams.set('sort', sort);
    url.searchParams.set('page', 1);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


function appendFilteredCards(index, filtered) {
    // console.log('index ' + index)
    // console.log(performance.now().toFixed(2) + ' start appendFilteredCards')
    if (index < filtered.length) {
        var item = filtered[index];
        // console.log(item.id)

        if (cardCache[item.id]) {
            // console.log('cached!')
            var card = cardCache[item.id].replace('"card"', '"card hiding"');
            resultsColumn.append(card);
            setTimeout(() => {
                resultsColumn.find('.card[data-id="' + item.id + '"]').removeClass('hiding');
            }, 50 * index);
            // console.log(performance.now().toFixed(2) + ' appended cached')
            appendFilteredCards(index + 1, filtered);
        } 
    } 
}

function pagination(pageData) {
    // console.log(pageData)
    var totalPages = pageData.total_pages;
    var currentPage = pageData.current_page;

    var pagesHtml = ``;
    for (var i = 1; i <= totalPages; i++) {
        pagesHtml = pagesHtml + '<div class="page ' + (currentPage == i ? 'active' : '') + '" data-page="' + i + '">' + i + '</div>';
    }

    paginationDiv.html(pagesHtml);

}


$(document).on('click','[data-whatson-listing-pagination] .page:not(.active)', function() {

    $('[data-whatson-listing-pagination] .page').removeClass('active');
    $(this).addClass('active');
    var section = getUrlParameter('type');
    if (!section) {
        section = 'all';
    }
    var sort = getUrlParameter('sort') ?? 'recent';
    var page = $(this).attr('data-page');
    var category = getUrlParameter('category') ?? '';
    if (!category) {
        category = 'all';
    }
    var location = getUrlParameter('location') ?? '';
    if (!location) {
        location = 'all';
    }
    var price = getUrlParameter('price') ?? '';
    if (!price) {
        price = 'all';
    }
    
    fetchWhatsOnData(section, location, price, category, sort, page)

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('type', section);
    url.searchParams.set('page', page);
    url.searchParams.set('category', category);
    url.searchParams.set('location', location);
    window.history.replaceState({}, document.title, url.toString());

    $('html, body').animate({
        scrollTop: $('.whats-on-section-listing').offset().top
    }, 500);

});


async function fetchWhatsOnData(section, location, price, category, sort, page) {
    var startTime = performance.now();
    console.log('Fetching whatson-listing.json...');

    var sectionQuery = '';
    var pageQuery = '';

    if (section) {
        var sectionQuery = 'type=' + section;
    }
    if (category) {
        var categoryQuery = '&category=' + category;
    }
    if (location) {
        var locationQuery = '&location=' + location;
    }
    if (price) {
        var priceQuery = '&price=' + price;
    }
    if (sort) {
        var sortQuery = '&sort=' + sort;
    }
    if (page) {
        var pageQuery = '&page=' + page;
    }
    
    try {
        const response = await $.ajax({
            type: 'get',
            url: '/whatson-listing.json?' + sectionQuery + locationQuery + priceQuery + categoryQuery + sortQuery + pageQuery,
        });
        
        console.log('success /whatson-listing.json?' + sectionQuery + locationQuery + priceQuery + categoryQuery + sortQuery + pageQuery);
        jsonData = response.data;
        pageData = response.meta.pagination;
        console.log(jsonData);
        

        $('.whats-on-section .row-cards-desktop').find('.card').each(function (index) {
            setTimeout(() => {
                $(this).addClass('hiding');
            }, (index + 1) * 50);
        });

        // var section = getUrlParameter('type');
        // var page = getUrlParameter('page');
        // if (section || page) {
        //     $('html, body').animate({
        //         scrollTop: $('.whats-on-section-listing').offset().top
        //     }, 500);
        // }


        resultsColumn.empty();
        resultsColumn.html('<div class="cards-loading">Loading...</div>');
        paginationDiv.html('');

        // Load cards into cache after fetching data

        
        
        console.log(performance.now().toFixed(2) + ' before preloadCards')
        preloadCards(function () {
            console.log("All cards preloaded.");
            // Add any additional initialization logic here
            

            resultsColumn.empty();
            appendFilteredCards(0, jsonData);
            pagination(pageData);
            var endTime = performance.now();
            var duration = (endTime - startTime) / 1000;
            console.log('DURATION ' + duration.toFixed(2))
            
        });

        if (jsonData.length == 0) {
            resultsColumn.html('<div class="cards-loading">Nothing found</div>');
        }


        

    } catch (error) {
        console.log('error whatson-listing.json');
        console.log(error);
    }
}


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  



function filterStuck(scrollTop) {
    var filterRowOffset = filterRow.offset().top - scrollTop;
    if (filterRowOffset > -50 && filterRowOffset < 50) {
        $('body').addClass('whats-on-filter-stuck');
    } else {
        $('body').removeClass('whats-on-filter-stuck');
    }
}




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SORT DROPDOWN
$(document).on('click','.sort-dropdown .btn', function(e) {
    e.stopPropagation();
    $('.sort-dropdown .btn').toggleClass('open');
    $('.category-dropdown .btn').removeClass('open');
    $('.location-dropdown .btn').removeClass('open');
    $('.price-dropdown .btn').removeClass('open');
});
$(document).on('click','.category-dropdown .btn', function(e) {
    e.stopPropagation();
    $('.category-dropdown .btn').toggleClass('open');
    $('.sort-dropdown .btn').removeClass('open');
    $('.location-dropdown .btn').removeClass('open');
    $('.price-dropdown .btn').removeClass('open');
});
$(document).on('click','.location-dropdown .btn', function(e) {
    e.stopPropagation();
    $('.location-dropdown .btn').toggleClass('open');
    $('.sort-dropdown .btn').removeClass('open');
    $('.category-dropdown .btn').removeClass('open');
    $('.price-dropdown .btn').removeClass('open');
});
$(document).on('click','.price-dropdown .btn', function(e) {
    e.stopPropagation();
    $('.price-dropdown .btn').toggleClass('open');
    $('.sort-dropdown .btn').removeClass('open');
    $('.category-dropdown .btn').removeClass('open');
    $('.location-dropdown .btn').removeClass('open');
});
$(document).on("click", function(e) {
    $('.sort-dropdown .btn').removeClass('open');
    $('.category-dropdown .btn').removeClass('open');
    $('.location-dropdown .btn').removeClass('open');
    $('.price-dropdown .btn').removeClass('open');
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
